import { MergeField, MergeSchema, getSchema } from '../../decorators';
import { ActivityEntityName, ContactEntity, Entity } from '../../../../entities';

@MergeSchema({
    entity: ActivityEntityName.Allocation
})
export class AllocationMergeData {

    @MergeField()
    _id: string;

    @MergeField()
    startDate: string;

    @MergeField()
    endDate: string;

    @MergeField()
    dateCompleted: string;

    @MergeField()
    completedNote: string;

    @MergeField()
    note: string;

    @MergeField()
    status: string;

    @MergeField()
    type: string;

    @MergeField()
    bookingStatus: string;

    @MergeField()
    source: string;

    job?: Entity;
    workOrder?: Entity;
    opportunity?: Entity;
    resource?: ContactEntity;
}

export const AllocationMergeSchema = getSchema(AllocationMergeData);